<template>
  <div class="consult_wrap">
    <div
      class="consult_img"
      v-if="hiddenProdFour1"
      :style="{ background: `url(${prodFour1.image}) 0 0 no-repeat`, backgroundSize: 'cover' }"
    >
      <div class="img_tit">{{ prodFour1.title }}</div>
      <div class="img_desc">
        {{ prodFour1.subtitle }}
      </div>
    </div>
    <template v-if="hiddenProdFour2">
      <div class="consult_title_wrap">
        <div class="consult_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 40%">
            <div class="consult_title">{{ prodFour2.title }}</div>
            <div class="consult_desc">
              {{ prodFour2.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="consult_card_wrap">
        <ConsultCard :consultList="consultList" :detailsArr="prodFour2Children" ref="consultCard" />
      </div>
    </template>

    <template v-if="hiddenProdFour3">
      <div class="consult_title_wrap">
        <div class="consult_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 40%">
            <div class="consult_title">{{ prodFour3.title }}</div>
            <div class="consult_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="func_wrap hidden-xs-only" style="background: #f4f9fc">
        <div class="func_wrap_inner">
          <div class="func_tit">{{ prodFour3.subtitle }}</div>
        </div>
        <div class="double_card_wrap">
          <el-row class="double_card" type="flex">
            <el-col :span="7" :xs="11" class="double_card_item"
              :style="{ 'backgroundImage': `url(${item.image})`, 'backgroundPosition': '90% 10%', 'backgroundRepeat': 'no-repeat', backgroundSize: '20%' }"
              v-for="(item, index) in prodFour3Children" :key="index">
              <div class="double_card_bg">
                {{ item.title }}</div>
              <p>{{ item.subTitle }}</p>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="func_wrap_mobile hidden-sm-and-up">
        <img src="@/assets/img/ys.png" alt="">
      </div>
    </template>
    <!-- <div class="appointment_wrap">
      <div class="appointment_txt">
        <h1>预约我们的产业专家<br>了解更多有关甜磕产业咨询服务详细信息</h1>
        <p>拨打我们的咨询热线 000-000-0000</p>
      </div>
    </div> -->
    <div class="product_shows_wrap" v-if="hiddenProdFour4">
      <div class="consult_title_wrap">
        <div class="consult_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="consult_title">{{ prodFour4.title }}</div>
            <div class="consult_desc">
              {{ prodFour4.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="with_center">
        <div class="bottom_img_wrap">
          <div class="bottom_img_item" v-for="(item, index) in prodFour4Children" :key="index">
            <div class="bottom_img">
              <img :src="item.image" alt="" />
              <div class="img_desc">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallMe />

    <BoottomTab />
  </div>
</template>

<script>
import ConsultCard from './ConsultCard.vue'
import CallMe from '@/components/callme/index'
import BoottomTab from './BoottomTab.vue'
import Constant from '../../utils/Constant';
import { leftLikeDict } from '../../api/system';
import { findDictHidden, findMainProp, findMainPropArr, transDictDataNotTypeMore, transDictDataTotal } from '../../utils';
export default {
  data() {
    return {
      hiddenProdFour1: true,
      hiddenProdFour2: true,
      hiddenProdFour3: true,
      hiddenProdFour4: true,
      prodFour1: {},
      prodFour2: {},
      prodFour2Arr: [],
      prodFour2Children: [],
      prodFour3: {},
      prodFour4: {},
      prodFour3Children: [],
      prodFour4Children: [],
      consultList: [
      ],
    }
  },
  components: {
    ConsultCard, CallMe, BoottomTab
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.PROD_FOUR1);
      if (res.data) {
        this.hiddenProdFour1 = findDictHidden(Constant.PROD_FOUR1, res.data.data)
        this.prodFour1 = findMainProp(res.data.data, Constant.PROD_FOUR1)
      }
      const res2 = await leftLikeDict(Constant.PROD_FOUR2);
      if (res2.data) {
        this.hiddenProdFour2 = findDictHidden(Constant.PROD_FOUR2, res2.data.data)
        this.prodFour2 = findMainProp(res2.data.data, Constant.PROD_FOUR2)
        this.prodFour2Arr = findMainPropArr(res2.data.data, Constant.PROD_FOUR2)
        this.consultList = this.prodFour2Arr.reduce((pre, cur) => {
          pre.push({
            tit: cur.type
          })
          return pre
        }, [])
        let totalArr = []
        totalArr = [...totalArr, ...(res2.data.data.find(v => v.dictKey === 'prod_four2Type1')?.children || [])]
        totalArr = [...totalArr, ...(res2.data.data.find(v => v.dictKey === 'prod_four2Type2')?.children || [])]
        totalArr = [...totalArr, ...(res2.data.data.find(v => v.dictKey === 'prod_four2Type3')?.children || [])]
        totalArr = [...totalArr, ...(res2.data.data.find(v => v.dictKey === 'prod_four2Type4')?.children || [])]
        totalArr = [...totalArr, ...(res2.data.data.find(v => v.dictKey === 'prod_four2Type5')?.children || [])]
        this.prodFour2Children = transDictDataTotal(totalArr, 'prod_four2Content')
        setTimeout(() => {
          this.$refs.consultCard?.changeIndex(0)
        });
      }

      const res3 = await leftLikeDict(Constant.PROD_FOUR3);
      if (res3.data) {
        this.hiddenProdFour3 = findDictHidden(Constant.PROD_FOUR3, res3.data.data)
        this.prodFour3 = findMainProp(res3.data.data, Constant.PROD_FOUR3)
        this.prodFour3Children = transDictDataNotTypeMore(res3.data.data.find(v => v.dictKey === 'prod_four3Title')?.children || [], 'prod_four3Content')
      }
      const res4 = await leftLikeDict(Constant.PROD_FOUR4);
      if (res4.data) {
        this.hiddenProdFour4 = findDictHidden(Constant.PROD_FOUR4, res4.data.data)
        this.prodFour4 = findMainProp(res4.data.data, Constant.PROD_FOUR4)
        this.prodFour4Children = transDictDataNotTypeMore(res4.data.data.find(v => v.dictKey === 'prod_four4Title')?.children || [], 'prod_four4Content')
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  }
}
</script>

<style lang="scss" scoped>
.consult_wrap {
  .consult_img {
    width: 100%;
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .consult_title_wrap {
    width: 100%;
    margin-top: 50px;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .consult_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;

        @media screen and (max-width: 768px) {
          flex: 3;
        }

        .consult_title {
          font-size: 40px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .consult_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;

          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 13px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .consult_card_wrap {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  .func_wrap {
    width: 100%;
    padding: 50px;
    background: url('../../assets/img/bg_0.png');
    background-size: 100% 100%;

    .func_wrap_inner {
      width: 70%;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .func_tit {
        font-size: 34px;
        font-weight: bold;
        text-align: center;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }

      .func_card {
        justify-content: space-between;
        margin-top: 40px;

        .card_item {
          background: #fff;
          box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.1);

          .item_top {
            width: 100%;
            height: 150px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background: url('../../assets/img/bg3.png');
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .item_bottom {
            padding: 15px;

            p {
              font-size: 16px;
              margin-top: 20px;
            }
          }
        }
      }

      .func_card_mobile {
        width: 100%;

        img {
          width: 100%;
          margin-top: 40px;
        }
      }
    }

    .double_card_wrap {
      width: 70%;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .double_card {
        justify-content: space-between;
        margin-top: 50px;

        @media screen and (max-width: 768px) {
          flex-wrap: wrap;
        }

        .double_card_item {
          height: 340px;
          background: #fff;
          padding: 30px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;

          box-shadow: 10px 10px 20px rgba(0, 0, 0, .1);

          @media screen and (max-width: 768px) {
            height: 140px;

            &:nth-child(n + 3) {
              margin-top: 20px;
            }
          }

          .double_card_bg {
            font-size: 24px;
            color: #000;
            font-weight: bold;
          }

          p {
            line-height: 40PX;
            font-size: 18px;
            margin-top: 30px;
          }
        }
      }
    }
  }

  .func_wrap_mobile {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .appointment_wrap {
    width: 100%;
    height: 350px;
    background: url('../../assets/img/bgcenter.c1d3caa.jpg') 0 0 no-repeat;
    background-size: 100% 100%;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
      height: 130px;
    }

    .appointment_txt {
      width: 70%;
      height: 100%;
      color: #fff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin: 0 auto;

      h1 {
        font-size: 26px;

        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          font-weight: normal;
        }
      }

      p {
        font-size: 20px;
        margin-top: 20px;

        @media screen and (max-width: 768px) {
          font-size: 0.75rem;
        }
      }
    }
  }

  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;

    .with_center {
      display: flex;
      justify-content: center;

      .bottom_img_wrap {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        @media screen and (max-width: 768px) {
          width: 100%;
          margin-top: 20px;
        }

        .bottom_img_item {
          width: 30%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
          margin: 20px;

          @media screen and (max-width: 768px) {
            width: 45%;
          }

          .bottom_img {
            width: 100%;
            position: relative;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .img_desc {
              position: absolute;
              bottom: 50%;
              transform: translateY(50%);
              width: 100%;
              text-align: center;
              color: #fff;
              font-size: 20px;
              font-weight: bold;

              @media screen and (max-width:768px) {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>